/* tslint:disable:typedef-whitespace */
/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {ICommand}            from '@/util/i.command';
import {TSOEditor}           from './t.s.o.editor';

/**
 *
 * @class SetNameCommand
 *
 * @brief reversible updates of the name column
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class SetNameCommand implements ICommand {

  private oldValue: string;
  private newValue: string;
  private editor:   TSOEditor;

  constructor(oldValue: string, newValue: string, editor: TSOEditor) {

    this.oldValue = oldValue;
    this.newValue = newValue;
    this.editor   = editor;
  }

  /** effect the command */
  execute() {

    this.editor.setName(this.newValue);
  }

  /** reverse the command's effects */
  unExecute() {

    this.editor.setName(this.oldValue);
  }

  /** return a string summary of this command */
  asString(): string {

    return '[name] ' + this.oldValue + ' => ' + this.newValue;
  }

}
